export function createShouldForwardProp(propsExcludedFromForwarding, forcedProps) {
  return function shouldForwardProp(prop, defaultValidator) {
    const isForcedProp = forcedProps ? forcedProps.includes(prop) : false;
    return !propsExcludedFromForwarding.includes(prop) && (defaultValidator(prop) || isForcedProp);
  };
}